import React, { useState } from 'react'
import { Form } from 'react-angle-dashboard-components'

export const PhoneControl = ({
  onChange,
  placeholder,
  required
}: {
  onChange: (value: string) => void
  placeholder: string
  required?: boolean
}) => {
  const [val, setVal] = useState('')
  const formatInput = (value: string) => {
    // if input value is falsy eg if the user deletes the input, then just return
    if (!value) {
      setVal(value)
      return
    }

    // clean the input for any non-digit values.
    const phoneNumber = value.replace(/[^\d]/g, '')

    // phoneNumberLength is used to know when to apply our formatting for the phone number
    const phoneNumberLength = phoneNumber.length

    // we need to return the value with no formatting if its less then four digits
    // this is to avoid weird behavior that occurs if you  format the area code too early

    if (phoneNumberLength < 4) {
      setVal(phoneNumber)
      return
    }

    // if phoneNumberLength is greater than 4 and less the 7 we start to return
    // the formatted number
    if (phoneNumberLength < 7) {
      setVal(`(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`)
      return
    }

    // finally, if the phoneNumberLength is greater then seven, we add the last
    // bit of formatting and return it.
    const formattedNumber = `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
      3,
      6
    )}-${phoneNumber.slice(6, 10)}`

    setVal(formattedNumber)
    onChange(formattedNumber.replace(/[^\d]/g, ''))
  }

  return (
    <Form.Control
      className="bg-white"
      required={required}
      value={val}
      maxLength={14}
      onChange={(e: any) => formatInput(e.target.value)}
      placeholder={placeholder}
    />
  )
}
